import{normalizePath,normalizeQuery}from"wild-wild-parser";

import{getOptions}from"./options.js";
import{getPathValue}from"./path.js";
import{iterateQuery}from"./query.js";






export const iterate=function*(target,query,opts){
const{opts:optsA,pathArray,queryArrays}=normalizeArgs(query,opts);

if(pathArray===undefined){
yield*iterateQuery(target,queryArrays,optsA);
return
}

const{entry,matches}=getPathValue(target,pathArray,optsA);

if(matches){
yield entry
}
};




export const list=(target,query,opts)=>{
const{opts:optsA,pathArray,queryArrays}=normalizeArgs(query,opts);

if(pathArray===undefined){
return[...iterateQuery(target,queryArrays,optsA)]
}

const{entry,matches}=getPathValue(target,pathArray,optsA);
return matches?[entry]:[]
};




export const get=(target,query,opts)=>{
const{opts:optsA,queryArrays,pathArray}=normalizeArgs(query,opts);

if(pathArray===undefined){
return iterateQuery(target,queryArrays,optsA).next().value
}

const{entry,matches}=getPathValue(target,pathArray,optsA);
return matches?entry:undefined
};

const normalizeArgs=(query,opts)=>{
const optsA=getOptions(opts);
const{pathArray,queryArrays}=normalizePathOrQuery(query);
return{opts:optsA,pathArray,queryArrays}
};


export const normalizePathOrQuery=(query)=>{
try{
return{pathArray:normalizePath(query)}
}catch{
return{queryArrays:normalizeQuery(query)}
}
};